import groq from 'groq'

export const frameBuilderProductSettingsObjectFragment = groq`
  "settings": *[
    _type == "frameBuilderSettings" &&
    locale == $locale
  ][0],
`
